import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BudgetSupportType } from 'src/app/shared/models/gql/rate.model';

@Component({
  standalone: true,
  imports: [IonicModule, NgIf, NgFor],
  selector: 'app-support-service-types',
  templateUrl: './support-service-types.component.html',
  styleUrls: ['./support-service-types.component.scss'],
})
export class SupportServiceTypesComponent {
  // Array containing budget support type objects
  @Input() budgetSupportTypes: BudgetSupportType[];

  // Flag to indicate whether this component is being used in any Last Minute Job pages. Important for defining correct css class.
  @Input() isLastMinuteJob = false;
}
